import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { registerDestructor } from '@ember/destroyable';
import { variation } from 'ember-launch-darkly';
import { BREAKPOINT_MD, isAboveBreakpoint } from 'my-phorest/utils/breakpoints';

export default class SidebarService extends Service {
  @service('browser/window') window;
  @tracked isOpen = isAboveBreakpoint(BREAKPOINT_MD);

  constructor() {
    super(...arguments);
    if (variation('release-auto-collapse-lhs')) {
      this.isOpen = false;
    }
    if (this.window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.isOpen) {
          this.isOpen = isAboveBreakpoint(BREAKPOINT_MD);
        }
      });

      this.resizeObserver.observe(document.body);

      registerDestructor(this, () => {
        this.resizeObserver.unobserve(document.body);
      });
    }
  }

  @action
  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }
}
